import { GenerationStatus } from "@brookbush/database";
import type { ExamAttemptSummaryExpanded } from "@brookbush/types";

import useSWR from "swr";

const useLatestExamAttemptSummary = (courseSlug: string | undefined) => {
	const key = courseSlug ? `/courses/${courseSlug}/exams/summary/latest` : null;

	return useSWR<ExamAttemptSummaryExpanded | null>(key, {
		refreshInterval: (data) => {
			if (!data) return 0;
			if (
				data.status === GenerationStatus.pending ||
				data.status === GenerationStatus.processing
			) {
				return 3000;
			}
			return 0;
		},
	});
};

export default useLatestExamAttemptSummary;
